import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const FAQS = [{
  q: '¿Es material digital?',
  a: 'Sí. Es 100% digital en PDF y lo descargás al instante.'
}, {
  q: '¿Necesito imprimir todo?',
  a: 'No. Podés imprimir por partes según lo que estén trabajando.'
}, {
  q: '¿Sirve si soy mamá/papá y no soy docente?',
  a: 'Sí. Está armado para que cualquiera pueda aplicarlo con guía y ejercicios progresivos.'
}, {
  q: '¿Sirve para docentes y terapeutas?',
  a: 'Sí. Es ideal como recurso de apoyo y práctica sistemática.'
}, {
  q: '¿Cuánto tiempo por día requiere?',
  a: 'Entre 5 y 10 minutos diarios (rutina realista, no “modo ejército”).'
}, {
  q: '¿Cuánto tarda en verse progreso?',
  a: 'Depende del punto de partida, pero el sistema está diseñado para avanzar con constancia durante 30 días.'
}, {
  q: '¿Qué pasa si no me sirve?',
  a: 'Tenés 7 días de garantía.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-gray-50" data-id="element-70">
      <div className="max-w-3xl mx-auto" data-id="element-71">
        <h2 className="text-4xl font-black text-center text-gray-900 mb-12" data-id="element-72">
          Preguntas frecuentes
        </h2>

        <div className="space-y-4" data-id="element-73">
          {FAQS.map((faq, index) => <div key={index} className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-sm" data-id="element-74">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-75">
                <span className="text-lg font-bold text-gray-900" data-id="element-76">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-77" />
              </button>

              <AnimatePresence data-id="element-78">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-79">
                    <div className="px-6 pb-5 text-gray-600 font-medium" data-id="element-80">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}